import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://pvslneograuwbnbnxlpw.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB2c2xuZW9ncmF1d2JuYm54bHB3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY4OTg2ODcsImV4cCI6MjA5MjQ3NDY4N30.27r_LAbmPsnSCJdhd-ZTx6PMLgAGb7Xogsrf8YQfAJ0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
